import React from 'react';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import { useTasks } from '../context/tasks_context';

export function TasksNewButton() {
  const { paths, showTaskModal } = useTasks();

  if (!paths.create) return null;

  return (
    <div>
      <Button.Secondary
        icon={faPlus}
        label="New Task"
        onClick={() => showTaskModal()}
      />
    </div>
  );
}
